import timeline from './timeline'

export default {
  screenLocked: 'écran bloqué',
  screenUnlocked: 'écran débloqué',

  timeline
}
